module.exports = __webpack_public_path__ + "img/ranking_3.9a298437.png";